import _default from './ScrollSync';
export { _default as default };
import _ScrollSync from './ScrollSync';
export { _ScrollSync as ScrollSync };